import { useState } from "react";
import { Button } from "../../ui/button";
import { Printer, Copy } from "lucide-react";
import { toast } from "sonner";
import { AutoTextarea } from "./shared";

const LINES = [
  ["feeling", "En ce moment, je ressens…"],
  ["trigger", "parce que…"],
  ["schema_mode", "Je sais que c'est mon schéma / mode…"],
  ["origin", "qui vient de…"],
  ["distortion", "Il me pousse à exagérer…"],
  ["belief", "Même si je crois que…"],
  ["reality_evidence", "la réalité, c'est que…"],
  ["urge", "Même si j'ai envie de…"],
  ["healthy_action", "je peux plutôt…"],
  ["healthy_adult_message", "Message de mon Adulte sain"],
];

export const FlashcardForm = ({ data, onChange }) => {
  const [side, setSide] = useState("fields");
  const set = (k) => (v) => onChange({ ...data, [k]: v });
  const copy = async () => { try { await navigator.clipboard.writeText(data.full_text || ""); toast.success("Texte copié"); } catch { toast.error("Copie impossible"); } };
  const print = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<html><head><title>${data.title || "Fiche mémo"}</title><style>body{font-family:Georgia,serif;max-width:640px;margin:40px auto;padding:24px;border:2px solid #333;border-radius:16px}h1{font-size:20px}p{font-size:15px;line-height:1.6;white-space:pre-wrap}</style></head><body><h1>${data.title || "Ma fiche mémo"}</h1><p>${(data.full_text || "").replace(/</g, "&lt;")}</p></body></html>`);
    w.document.close(); w.print();
  };
  return (
    <div className="space-y-3" data-testid="flashcard-form">
      <div className="flex items-center gap-2 flex-wrap">
        <input className="flex-1 min-w-[200px] text-base font-semibold rounded-lg border border-border bg-background px-3 py-1.5" value={data.title || ""} onChange={(e) => set("title")(e.target.value)} placeholder="Titre de la fiche (ex. « Quand le Juge revient »)" data-testid="flashcard-title" />
        <div className="flex items-center rounded-lg bg-muted p-0.5">
          <button onClick={() => setSide("fields")} className={`px-2.5 py-1 text-xs rounded-md ${side === "fields" ? "bg-background shadow" : "text-muted-foreground"}`} data-testid="flashcard-side-fields">Champs</button>
          <button onClick={() => setSide("card")} className={`px-2.5 py-1 text-xs rounded-md ${side === "card" ? "bg-background shadow" : "text-muted-foreground"}`} data-testid="flashcard-side-card">Carte</button>
        </div>
        <Button variant="ghost" size="sm" className="gap-1.5" onClick={copy} data-testid="flashcard-copy"><Copy className="w-3.5 h-3.5" /> Copier</Button>
        <Button variant="ghost" size="sm" className="gap-1.5" onClick={print} data-testid="flashcard-print"><Printer className="w-3.5 h-3.5" /> Imprimer</Button>
      </div>
      {side === "fields" ? (
        <div className="grid md:grid-cols-2 gap-2">
          {LINES.map(([k, label]) => (
            <div key={k} className={k === "healthy_adult_message" || k === "reality_evidence" || k === "healthy_action" ? "md:col-span-2" : ""}>
              <label className="text-xs font-medium text-primary">{label}</label>
              <AutoTextarea value={data[k]} onChange={set(k)} rows={k === "reality_evidence" || k === "healthy_action" ? 3 : 2} testId={`flashcard-${k}`} />
            </div>
          ))}
        </div>
      ) : (
        <div className="rounded-2xl border-2 border-primary/50 bg-gradient-to-br from-primary/5 to-background p-6 shadow-sm" data-testid="flashcard-card">
          <AutoTextarea value={data.full_text} onChange={set("full_text")} rows={10} className="text-base leading-relaxed bg-transparent border-0 focus:ring-0 font-serif" placeholder="Texte complet de la fiche mémo (généré par l'IA ou rédigé à la main)…" testId="flashcard-full-text" />
        </div>
      )}
    </div>
  );
};
